import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/services/global.service';

import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.css']
})
export class HomepageComponent implements OnInit {
  header: Array<any> = [];
  homepage: any;
  token: any;

  constructor(
    private globals: GlobalService,
    private cookie: CookieService
  ) {
    
   }

  ngOnInit() {
    this.header= this.globals.header;
    if(!this.token){
      this.token = this.globals.getToken();
    }
    this.checkToken();
    this.getHome();
  }

  checkToken(){
    let tk = this.globals.tokenName;
    if(this.cookie.check(tk)){
      this.globals.checkToken(this.cookie.get(tk)).subscribe(
      res => {
        if(res.error) {
          return this.globals.errorSniffer(res.error);
        } else {
        }
      },
      err => {
        console.error("checkToken -> ERR",err);
      })
    } else {
      this.globals.goToLogin();
    }
  }

  getHome(){
    this.globals.getHome(this.token).subscribe(
      res => {
        this.homepage = res;
      },
      err => {
        console.error("Errore: ", err);
        
      }
    )
  }

}
